module.exports = __webpack_public_path__ + "static/media/reportsIcon.54eccf1f.svg";